import { Component, OnInit } from "@angular/core";
import { Product } from "../../models/product";
import { Seo } from "../../models/api/seo.model";
import { ProductService } from "../../services/product.service";
import { SEOService } from "../../services/seo.service";
import { MetaTag } from "../../models/api/metaTag.model";
import { PropertyTag } from "../../models/api/propertyTag.model";
import { Contact } from "../../models/api/contact";
import { HttpErrorResponse } from "@angular/common/http";
import { ApiService } from "../../services/api.service";
// for cart
import { UNITS, Price } from "../../models/price";
import { Item } from "../../models/item";
import { Quantity } from "../../models/quantity";
import { CartService } from "../../services/cart.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  topSelling: Product[] = new Array();
  topTrending: Product[] = new Array();
  topFeatured: Product[] = new Array();
  todayDeals: Product[] = new Array();
  products: Product[] = new Array();
  trending: Product[] = new Array();
  brands: Product[] = new Array();
  categories: string[] = new Array();
  seo = new Seo();
  tags = new Array();
  date: Date;
  properties = new Array();
  schema;
  navigationSchema;
  contact: Contact = new Contact();
  isLoading = false;
  buttonMsg = "Send Message";
  email: string = "Subscribe";
  subscrButtonMsg = "Subscribe";
  // for cart
  keyUp = "";
  quant: number = 1;
  chosenUnit: string = UNITS[0].name;

  constructor(
    private productService: ProductService,
    private apiService: ApiService,
    private cartService: CartService,
    private seoService: SEOService
  ) {
    var now = new Date(),
      y = now.getFullYear(),
      m = now.getMonth();
    this.date = new Date(y, m + 1, 0);
    console.log(this.date.toUTCString());
  }

  ngOnInit() {
    this.products = this.productService.findAll();
    this.topFeatured = this.productService.findRandomAndExcludeMany(6, []);
    this.topFeatured.sort((a, b) => a.name.localeCompare(b.name));
    this.setCategories();
  }

  setCategories() {
    this.productService.findAll().forEach((p) => {
      if (
        !this.categories.includes(p.category.toLowerCase()) &&
        p.category != ""
      ) {
        this.categories.push(p.category.toLowerCase());
      }
    });
  }

  getCategroyCount(category: string) {
    let count = 0;
    if (category.toLowerCase() === "all") {
      count = this.productService.findAllCategories().length;
    } else {
      this.productService.findByCategory(category).forEach((product) => {
        if (product.category.toLowerCase() === category.toLowerCase()) {
          count++;
        }
      });
    }
    return count;
  }

  addToCart(product) {
    this.chosenUnit = product.prices[0].unit;
    if (this.keyUp) this.quant = parseFloat(this.keyUp);
    if (this.chosenUnit && Number.isFinite(this.quant) && !(this.quant <= 0)) {
      let item: Item = new Item();
      let quant: Quantity = new Quantity();
      quant.quantity = this.quant;
      quant.unit = this.chosenUnit;
      item.product = product;
      item.quantity = quant;
      this.cartService.add(item);
    } else {
      this.quant = 1;
      Swal({
        title: "Bad Quantity",
        text: "Please enter a non zero quantity value to proceed",
        type: "warning",
        confirmButtonText: "Ok got it!",
        confirmButtonColor: "#07a763",
      });
    }
  }

  // getProductStars(product: Product) {
  //   let stars = 0;
  //   if (product.comments.length <= 0) {
  //     return product.stars;
  //   } else {
  //     for (var i = 0; i < product.comments.length; i++) {
  //       stars += product.comments[i].stars;
  //     }
  //     if (stars > 100) {
  //       return 90;
  //     } else {
  //       return Math.ceil(stars / product.comments.length);
  //     }
  //   }
  // }

  submit() {
    this.buttonMsg = "Loading...";
    this.apiService.contact(this.contact).subscribe(
      (data: any) => {
        this.isLoading = true;
        Swal({
          title: "Thanks!",
          text: "Thank you! Your message has been received. We will contact you as soon as possible",
          type: "success",
          confirmButtonText: "Ok",
          confirmButtonColor: "#07a763",
        });
        this.contact = new Contact();
        this.isLoading = false;
        this.buttonMsg = "Send Message";
      },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        Swal({
          title: "Error!",
          text: "Unable to send message. Make sure you are connected to the internet",
          type: "warning",
          confirmButtonText: "Ok got it!",
          confirmButtonColor: "#07a763",
        });
        this.buttonMsg = "Send Message";
      }
    );
  }

  submitEmail() {
    this.email = "Subscribing....";
    this.apiService.contact(this.contact).subscribe(
      (data: any) => {
        this.isLoading = true;
        Swal({
          title: "Thanks!",
          text: "Thank you! Your email has been subscribed.",
          type: "success",
          confirmButtonText: "Ok",
          confirmButtonColor: "#07a763",
        });
        this.contact = new Contact();
        this.isLoading = false;
        this.email = "Subscribe";
      },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        Swal({
          title: "Error!",
          text: "Unable to subscribe. Make sure you are connected to the internet",
          type: "warning",
          confirmButtonText: "Ok got it!",
          confirmButtonColor: "#07a763",
        });
        this.email = "Subscribe";
      }
    );
  }

  triggerFalseClick() {
    let element: HTMLElement = document.getElementById(
      "auto_trigger"
    ) as HTMLElement;

    element.click();
  }

  submitSubscribe() {
    this.subscrButtonMsg = "Loading...";
    this.apiService.contact(this.contact).subscribe(
      (data: any) => {
        this.isLoading = true;
        Swal({
          title: "Thanks!",
          text: "Thank you! Your message has been subscribe.",
          type: "success",
          confirmButtonText: "Ok",
          confirmButtonColor: "#07a763",
        });
        this.contact = new Contact();
        this.isLoading = false;
        this.subscrButtonMsg = "Subscribe";
        this.triggerFalseClick();
      },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        Swal({
          title: "Error!",
          text: "Unable to Subscribe email. Make sure you are connected to the internet",
          type: "warning",
          confirmButtonText: "Ok got it!",
          confirmButtonColor: "#07a763",
        });
        this.subscrButtonMsg = "Subscribe";
        this.triggerFalseClick();
      }
    );
  }
}
